import { render } from "./hAccordion.vue?vue&type=template&id=1dead2d0&scoped=true&ts=true"
import script from "./hAccordion.vue?vue&type=script&lang=ts"
export * from "./hAccordion.vue?vue&type=script&lang=ts"

import "./hAccordion.vue?vue&type=style&index=0&id=1dead2d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dead2d0"]])

export default __exports__